import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DistrictProvider } from "@/context/DistrictContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Portal from "@/pages/Portal";
import HeritageMap from "@/pages/HeritageMap";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App min-h-screen bg-ivory">
            <BrowserRouter>
                <DistrictProvider>
                    <Header />
                    <Routes>
                        <Route path="/" element={<Portal />} />
                        <Route path="/heritage-map" element={<HeritageMap />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                    </Routes>
                    <Footer />
                </DistrictProvider>
            </BrowserRouter>
            <Toaster />
        </div>
    );
}

export default App;
